import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';
import './Header.css';

const Header: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const pageInfo: Record<string, { title: string; subtitle: string }> = {
    '/': { title: 'Panel de Control', subtitle: 'Resumen general de la plataforma' },
    '/usuarios': { title: 'Usuarios', subtitle: 'Inversores, administradores y responsables comerciales' },
    '/productos': { title: 'Productos', subtitle: 'Gestión de productos CRV, CRA y PH' },
    '/inversiones': { title: 'Inversiones', subtitle: 'Fichas de inversión por producto' },
    '/cuadro-amortizacion': { title: 'Calendario de pagos', subtitle: 'Pagos de intereses a cuenta y fidelización por trimestre' },
    '/movimientos': { title: 'Movimientos', subtitle: 'Entradas y salidas de capital e intereses por ficha' },
    '/amortizaciones': { title: 'Amortizaciones', subtitle: 'Amortizaciones anticipadas de capital negociadas con cada inversor' },
    '/seguimiento-cra': { title: 'Seguimiento CRA', subtitle: 'Inmuebles e ingresos y gastos' },
  };

  const currentPage = pageInfo[location.pathname]
    || (location.pathname.startsWith('/seguimiento-cra/') ? pageInfo['/seguimiento-cra'] : null)
    || (location.pathname.startsWith('/amortizaciones/') ? pageInfo['/amortizaciones'] : null);

  const pageTitle = currentPage?.title || '';
  const pageSubtitle = currentPage?.subtitle || '';

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const initials = user?.nombre
    ? user.nombre.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
    : 'U';

  return (
    <header className="header">
      <div className="header-left">
        {pageTitle && (
          <div className="page-title-group">
            <h2 className="page-title">{pageTitle}</h2>
            {pageSubtitle && <p className="page-subtitle">{pageSubtitle}</p>}
          </div>
        )}
      </div>
      <div className="header-right">
        <button
          className="theme-toggle"
          onClick={toggleTheme}
          aria-label="Cambiar tema"
          title={theme === 'light' ? 'Modo oscuro' : 'Modo claro'}
        >
          {theme === 'light' ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="5" />
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </svg>
          )}
        </button>
        <div className="user-menu">
          <span className="user-name">{user?.nombre || 'Usuario'}</span>
          <div className="user-avatar">{initials}</div>
        </div>
        <button
          className="logout-button"
          onClick={handleLogout}
          title="Cerrar sesión"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </button>
      </div>
    </header>
  );
};

export default Header;
